import supportedFeatures from '../../supported-features.json'

export const shieldsLogos = supportedFeatures.shieldsLogos as string[]
export const simpleIcons = supportedFeatures.simpleIcons as string[]
export const advertisedStyles = supportedFeatures.advertisedStyles as string[]
